import { UntypedFormBuilder } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Actions, Store, ofActionSuccessful } from "@ngxs/store";
import {
    Component,
    Input,
    Inject,
    ChangeDetectorRef,
    OnInit,
} from "@angular/core";
import { Subject } from "@microsoft/signalr";
import { AddEscalationHistoryAction, LoadEscalatedHistoryAction, LoadEscalatedHistorySuccessAction } from "@ngxs-store/control-tower-store/control-tower.actions";
import { EscalationHistoryModel } from "@core/services/api.service";
import { AuthState } from "@ngxs-store/auth-store/auth.state";
import { AddBmwMessageByIdAction, AddCustomsMessageByIdAction, LoadBmwHistoryAction, LoadBmwHistorySuccessAction, LoadCustomsHistoryAction, LoadCustomsHistorySuccessAction } from "@ngxs-store/customs-store/customs.actions";

@Component({
    selector: "app-escalation-chat-dialog",
    templateUrl: "./escalation-chat-dialog.component.html",
    styleUrls: ["./escalation-chat-dialog.component.scss"]
})
export class EscalationChatDialogComponent  implements OnInit {
    @Input() isLoading: boolean;
    @Input() isMobileMode: boolean;
    @Input() id: number;
    @Input() messages: EscalationHistoryModel[];
    newMessage: string = "";
    status: boolean;
    topic: string;
    amcoId: number;
    priority: string;
    isCustomsChat: boolean = false;
    isBmwChat: boolean = false;
    hasOpenChat: boolean = false;
    isFromCustomsPage: boolean = false;

    private refreshDialogSubject = new Subject<void>();
    hasControlTowerRole: boolean = false;
    hasCustomsRole: boolean = false;

    constructor(
        private formBuilder: UntypedFormBuilder,
        public dialogRef: MatDialogRef<EscalationChatDialogComponent>,
        private cdr: ChangeDetectorRef,
        private actions$: Actions,
        @Inject(MAT_DIALOG_DATA) data: any,
        private store: Store
    ) {
        this.id = data.id;
        this.topic = data.topic;
        this.status = data.status;
        this.amcoId = data.amcoId;
        this.priority = data.prio;
        this.isCustomsChat = data.isCustomsChat;
        this.isBmwChat = data.isBmwChat ?? false;
        this.isFromCustomsPage = data.isFromCustomsPage ?? false;
        //Get messages
        if(this.isBmwChat){
            this.loadBmwMessages();
        }else if(this.isCustomsChat){
            this.loadCustomsMessages();
        }else{
            this.loadMessages();
        }
    }

    ngOnInit(): void {
        const sub = this.actions$
        .pipe(ofActionSuccessful(LoadEscalatedHistorySuccessAction))
        .subscribe((resp: any) => {
            if(resp){
                this.messages = resp.payload.history;
            }
          sub.unsubscribe();
        });

        const sub2 = this.actions$
        .pipe(ofActionSuccessful(LoadCustomsHistorySuccessAction))
        .subscribe((resp: any) => {
            if(resp){
                this.messages = resp.payload.history;
            }
          sub2.unsubscribe();
        });

                const sub3 = this.actions$
                .pipe(ofActionSuccessful(LoadBmwHistorySuccessAction))
                .subscribe((resp: any) => {
                        if(resp){
                                this.messages = resp.payload.history;
                        }
                    sub3.unsubscribe();
                });

        const token = this.store.selectSnapshot(AuthState.getDecodedToken);

        if (
            token.roles.findIndex(
                (hasRoleFn) =>
                    hasRoleFn === "ControlTowerUser"
            ) > -1
        ) {
            this.hasControlTowerRole = true;
        } else {
            this.hasControlTowerRole = false;
        }

        if (
            token.roles.findIndex(
                (hasRoleFn) =>
                    hasRoleFn === "Customs"
            ) > -1
        ) {
            this.hasCustomsRole = true;
        } else {
            this.hasCustomsRole = false;
        }
    }


    onCancelClick(): void {
        this.dialogRef.close(true);
    }

    addMessage() {
        const trimmedMessage = this.newMessage.trim();
        if (!trimmedMessage) return;

        const isCustoms = this.isCustomsChat;
        const isBmw = this.isBmwChat;
        const roleType = isCustoms
            ? (this.isFromCustomsPage ? "Customs" : "Tracking")
            : isBmw
                ? "BMW"
            : (this.hasControlTowerRole ? "ControlTower" : "AllGroups");

        const newMessageObj: EscalationHistoryModel = {
            message: trimmedMessage,
            type: roleType,
            createdBy: "You",
            createdAt: new Date(),
            init: () => { throw new Error("Function not implemented."); },
            toJSON: () => { throw new Error("Function not implemented."); }
        };

        this.messages.push(newMessageObj);
        this.cdr.detectChanges();

        const isCustomRole = isCustoms && this.isFromCustomsPage;
        const action = isBmw
            ? new AddBmwMessageByIdAction(this.id, trimmedMessage, true)
            : isCustoms
            ? new AddCustomsMessageByIdAction(this.id, trimmedMessage, isCustomRole)
            : new AddEscalationHistoryAction(this.id, trimmedMessage, this.hasControlTowerRole, this.topic);

        const reloadMessages = isBmw
            ? this.loadBmwMessages.bind(this)
            : isCustoms
                ? this.loadCustomsMessages.bind(this)
                : this.loadMessages.bind(this);

        this.store.dispatch(action).subscribe({
            next: reloadMessages,
            error: () => {
                this.messages.pop();
                this.cdr.detectChanges();
            }
        });

        this.newMessage = "";
    }

    loadMessages(){
        this.store.dispatch(new LoadEscalatedHistoryAction(this.id, this.topic));
        this.triggerDialogRefresh();
    }

    loadCustomsMessages(){
        this.store.dispatch(new LoadCustomsHistoryAction(this.id, this.amcoId));
        this.triggerDialogRefresh();
    }

    loadBmwMessages(){
        this.store.dispatch(new LoadBmwHistoryAction(this.id, this.amcoId));
        this.triggerDialogRefresh();
    }

    triggerDialogRefresh() {
        this.refreshDialogSubject.next();
    }

}
